import { render } from "./LoaderWidget.vue?vue&type=template&id=85d9be74&ts=true"
import script from "./LoaderWidget.vue?vue&type=script&lang=ts"
export * from "./LoaderWidget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__